module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ViewEventItems"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    ref: "itemsTableWrapper",
    staticClass: "ViewEventItems__tableWrapper"
  }, [_c('selectable-grid', {
    attrs: {
      "rows": _vm.totalRows,
      "columns": 14
    },
    scopedSlots: _vm._u([
      ["default", function(grid) {
        return [_vm._l((_vm.discountedProducts), function(discount, index) {
          return _c('discounted-product', {
            key: discount.uuid,
            attrs: {
              "discount": discount,
              "hideStartDate": _vm.eventStartDate,
              "hideEndDate": _vm.eventEndDate,
              "customer-groups": _vm.customerGroups,
              "row": index,
              "active-row": grid.activeRow
            }
          })
        }), _vm._v(" "), _vm._l((_vm.specialPromotions), function(promotion, index) {
          return [(promotion.type == 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE' || promotion.type == 'MULTIBUY_GET_PERCENTAGE_OFF' || promotion.type == 'MULTIBUY_GET_SUM_OFF') ? _vm._l((promotion.requirements.purchasedProducts), function(item, itemIndex) {
            return _c('special-promotion', {
              key: promotion.uuid + '_' + item.plu,
              attrs: {
                "promotion": promotion,
                "item": item,
                "itemIndex": itemIndex,
                "hideStartDate": _vm.eventStartDate,
                "hideEndDate": _vm.eventEndDate,
                "customer-groups": _vm.customerGroups,
                "row": _vm.discountedProducts.length + index,
                "active-row": grid.activeRow
              },
              on: {
                "show-promotion": _vm.showPromotion
              }
            })
          }) : _vm._l((promotion.rewards.awardedProducts), function(item, itemIndex) {
            return _c('special-promotion', {
              key: promotion.uuid + '_' + item.plu,
              attrs: {
                "promotion": promotion,
                "item": item,
                "itemIndex": itemIndex,
                "hideStartDate": _vm.eventStartDate,
                "hideEndDate": _vm.eventEndDate,
                "customer-groups": _vm.customerGroups,
                "row": _vm.discountedProducts.length + index,
                "active-row": grid.activeRow
              },
              on: {
                "show-promotion": _vm.showPromotion
              }
            })
          })]
        })]
      }]
    ])
  }, [_c('th', {
    slot: "header"
  }, [_vm._v("\n              PLU\n            ")]), _vm._v(" "), _c('th', {
    slot: "header"
  }, [_vm._v("\n              Product\n            ")]), _vm._v(" "), _c('th', {
    slot: "header"
  }, [_vm._v("\n              Type\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-4",
    slot: "header"
  }, [_vm._v("\n              Customer Group\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n              Start date\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n              End date\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n              Page\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n              Position\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n              Regular price\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n              Cost\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n              Sales price\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-2",
    slot: "header"
  }, [_vm._v("\n              Margin\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-3",
    slot: "header"
  }, [_vm._v("\n              Target margin\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "ViewEventItems_column--width-4",
    slot: "header"
  }, [_vm._v("\n              Reward money earned\n            ")])])], 1)]), _vm._v(" "), (_vm.totalRows === 0) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n        No discounts or promotions added yet\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ViewEventItems__scroller",
    attrs: {
      "id": "ViewEventItems__scroller"
    },
    on: {
      "scroll": _vm.scrollItems
    }
  }, [_c('div', [_vm._v(" ")])]), _vm._v(" "), _c('view-promotion', {
    attrs: {
      "value": _vm.promotionBeingViewed,
      "shown": _vm.viewPromotionShown
    },
    on: {
      "hide": function($event) {
        _vm.viewPromotionShown = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-37978128"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ViewEvent/ViewEventItems.vue
// module id = 1679
// module chunks = 1